module.exports = __webpack_public_path__ + "img/zhihu-square.75d78c0e.svg";